export function roundToPrecision(n, p) {
  return Math.round(n * (10 ** p)) / (10 ** p);
}

export function getNavTopIndex(tab, data) {
  const array = ['home', 'stories', 'contact', 'about', 'careers'];
  let res = 0;
  for (let i = 0; i < array.length; i++) {
    if (tab == array[i]) {
      return res;
    }
    if (data[array[i]] != '') res++;
  }
  return res;
}

export function getLang(lang) {
  if (lang == undefined) {
    return 'zh';
  }
  return lang;
}


export function getMobile() {
  if (/AppleWebKit.*Mobile/i.test(navigator && navigator.userAgent) || (/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator && navigator.userAgent))) {
    try {
      if (/iPhone|mac|iPod|iPad/i.test(navigator && navigator.userAgent)) {
        return false;
      } else {
        return true;
      }
    } catch (e) {
    }
  } else {
    return false;
  }
}

export function getPixelSource() {
  return localStorage.getItem('pixel_source') || '';
}

/** 将蛇形数据转换为驼峰 */
export function snakeToCamel(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(snakeToCamel);
  }

  return Object.keys(obj).reduce((result, key) => {
    const camelKey = key.replace(/_([a-z])/g, (match, p1) => p1.toUpperCase());
    result[camelKey] = snakeToCamel(obj[key]);
    return result;
  }, {});
}

export function getUserAgent() {
  let userAgent = '';
  if (typeof navigator !== 'undefined') {
    userAgent = navigator?.userAgent?.toLowerCase();
  }

  if (/iphone|ipad|ipod|ios/i.test(userAgent)) {
    // 用户机型是iOS
    return 'ios';
  } else if (/android/i.test(userAgent)) {
    // 用户机型是安卓
    return 'android';
  }
  return 'ios';
}

export function parseJSON(json) {
  try {
    if (typeof json === 'object') {
      return json;
    }
    return JSON.parse(json);
  } catch (error) {
    console.error(error);
    return {};
  }
}


export function transClientLanToLocal(lan) {
  if (lan === 'zh-Hant' || lan === 'zh-Hant-HK') return 'zh-Hant';
  if (lan === 'zh-Hans') return 'zh-CN';
  return lan;
}


export function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}


// x 到 y 的随机整数
export function getRandomInt(x, y) {
  if (x === y) {
    return x;
  }
  return Math.floor(Math.random() * (y - x + 1)) + x;
}

export function sendPoint(params) {
  Object.defineProperty(params, 'system', {
    value: getUserAgent(),
    writable: true,
    configurable: true,
    enumerable: true,
  });
  const accessToken = getCookie('access-token'); // 拿到用户的token
  let url = '/web/event?';
  Object.entries(params).forEach((item) => {
    url += `${item[0]}=${item[1]}&`;
  });
  const init = {};
  if (accessToken) init.headers = { Authorization: `Bearer ${accessToken}` };
  fetch(url.slice(0, -1), init);
}

export function thousandsSeparator(n: number): string {
  const strSplit = n.toString().split('.');
  const integer = strSplit[0];
  const decimal = strSplit[1] || '';
  return integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + decimal;
}